import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType, Geofence, GeofencePointsType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'Paddock';

export type PaddockProps = {
  points: GeofencePointsType[];
  pause?: boolean;
};

export class Paddock extends Geofence implements PaddockProps {
  constructor(ob: Partial<PaddockProps>) {
    super({ type: typeName, ...ob });
    this.points = ob.points ?? [];
  }

  points: GeofencePointsType[];
  pause?: boolean;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of the field',
      },
      type: {
        type: 'String',
        editable: true,
        label: 'Type',
        name: 'type',
        description: 'Type of field eg grazing, crop, fallow',
      },
      points: {
        type: 'object',
        editable: true,
        label: 'Geopoints',
        name: 'Geopoints',
        description: 'External boundaries of field',
      },
    };
  };
}
